
/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  CharterResource,
} from '../models';
import {
    CharterResourceFromJSON,
    CharterResourceToJSON,
} from '../models';

/**
 * 
 */
export class PublicFreelancerCharterApi extends runtime.BaseAPI {

    /**
     * Returns charter status with associated information and charter display blocks 
          */
    async getCharterWithBlocksRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<CharterResource>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<CharterResource>({
            path: `/profile/public-api/charter-display`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=CharterResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Returns charter status with associated information and charter display blocks 
          */
    async getCharterWithBlocks(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<CharterResource> {
        const response = await this.getCharterWithBlocksRaw(initOverrides);
        return response._data;
    }

}
